import keyMirror from "keymirror";

const actions = {
  GET_RESTRICTED_HUBS: null,
  GET_RESTRICTED_HUBS_SUCCESS: null,
  GET_RESTRICTED_HUBS_ERROR: null,
  GET_RESTRICTED_HUBS_CLEAR: null,
};

export default keyMirror(actions);
